import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import { gsColors } from '../../styles/Variables'
import { useFormState } from 'react-final-form'

const TextArea = styled.textarea`
  resize: none;
  margin-bottom: 0.5rem;
  width: 100%;
  padding: 16px;
  height: 140px;
  min-height: 140px;
  border: 1px solid ${props => props.hasError ? gsColors.errorRed : gsColors.paleSlate};
  transition: all 0.5s ease;

  font-family: 'Euclid';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.02em;

  ${mq('max', '768px')} {
    font-size: 16px;
  }

  &:focus {
    outline: none;
    border: 1px solid ${gsColors.black};
  }

  &::placeholder {
    color: ${({ hasError }) => hasError ? gsColors.errorRed : gsColors.meredithGrey };
  }
`

const TextAreaField = ({ input, meta, ...rest }) => {
  const { submitFailed } = useFormState({ subscription: { submitFailed: true } })
  const error = submitFailed && meta?.error
  return <TextArea hasError={error} {...input} {...rest} />
}

export default TextAreaField
